import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import DashboardLayout from "cxfcomponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "cxfcomponents/Navbars/DashboardNavbar";
import { useAuth0 } from "@auth0/auth0-react";
import CircularProgress from "@mui/material/CircularProgress";

function HealthCheck({ serviceUrl }) {
  const { isLoading: authLoading } = useAuth0();
  const [status, setStatus] = useState("Checking...");
  const [isLoading, setIsLoading] = useState(true);

  const checkHealth = async () => {
    setIsLoading(true);
    setStatus("Checking...");

    // Delay the execution of the fetch request
    setTimeout(async () => {
      try {
        const response = await fetch(serviceUrl);
        if (response.ok) {
          setStatus("Service is healthy!");
        } else {
          setStatus("Service is not healthy");
        }
      } catch (error) {
        setStatus(`Error checking service health: ${error.message}`);
      } finally {
        setIsLoading(false);
      }
    }, 2000); // Delay for 2 seconds
  };

  useEffect(() => {
    checkHealth();
  }, [serviceUrl]);

  return (
    <>
      <div style={{
        padding: "8px",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        backgroundColor: "var(--main-bg-color)"
      }}>
        <DashboardNavbar />
      </div>
      <DashboardLayout>
        <DashboardNavbar />
        <SoftBox p={2}>
          <Grid container spacing={3} justifyContent="center" alignItems="center">
            <Grid size={{ xs: 12 }}>
              <SoftBox>
                <SoftTypography variant="h2" color="dark" textGradient fontWeight="bold">
                  Health Checker
                </SoftTypography>
                <SoftTypography variant="body1" color="text">
                  Status: {status}
                </SoftTypography>
                <SoftBox mt={4} mb={2}>
                  <SoftButton
                    onClick={checkHealth}
                    disabled={isLoading || authLoading}
                    variant={isLoading ? "outlined" : "gradient"}
                    color="dark"
                    startIcon={isLoading ? <CircularProgress size={20} /> : null}
                  >
                    {isLoading ? "Checking..." : "Check Health"}
                  </SoftButton>
                </SoftBox>
              </SoftBox>
            </Grid>
          </Grid>
        </SoftBox>
      </DashboardLayout>
    </>
  );
}

export default HealthCheck;
